export function SemaforoBoolFilter(bool) {
  return bool === true ? "VERDE" : "CINZA";
}
